import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleFilled, RedoOutlined, ToolOutlined } from '@ant-design/icons';
import { useNotification } from '../../../../Helper/NotificationProvider';
import '../../Events.scss'
import { fetchLocations, patchLocation } from '../../../../slices/locationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { addMatching } from '../../../../slices/matchingSlice';
import { patchEvent } from '../../../../slices/eventSlice';

const ResetButton = ({ location, guestList, event, fetchEvent, patcheData, setPatchedData, template, marginLeft }) => {
  const { openNotification } = useNotification();
  const { confirm } = Modal;
  const dispatch = useDispatch();

  const showResetConfirm = () => {
    confirm({
      title: template === "Default" ? 'Stühle zurücksetzen' : "Wartungsdisplay anzeigen",
      icon: <ExclamationCircleFilled />,
      content: template === "Default" ? 'Sind Sie sicher, dass Sie alle Stühle des Events zurücksetzen wollen?' :
        'Sind Sie sicher, dass Sie alle Stühle des Events auf das Wartungsdisplay umschalten wollen?',
      okText: 'Ja',
      okType: 'danger',
      cancelText: 'Nein',
      onOk() {
        handleReset(location, guestList)
      },
      onCancel() {
      },
    });
  };

  const handleReset = async (location, guestList) => {
    try {
      const updatedGuestList = guestList.map((guest) => {
        return {
          ...guest,
          name: "",
          surname: "",
          title: "",
          companyInfo: "",
          message: "",
          matching: {
            customFields: {},
            matched: false,
            label: "",
            template: ""
          }
        };
      });

      const updatedScanPaths = location?.scanPaths.map((scanPath) => {
        if (!scanPath.path || scanPath.path.length === 0) {
          return scanPath;
        }

        return {
          ...scanPath,
          currentMatchingMarker: scanPath.path[0],
        };
      });

      await dispatch(
        patchLocation({
          locationId: location._id,
          updateData: {
            scanPaths: updatedScanPaths,
          },
        })
      );

      await dispatch(patchEvent({
        eventId: event.key,
        changes: {
          guestList: updatedGuestList
        }
      }))


      const labels = guestList
        .filter((guest) => !!guest.matching?.label)
        .map((guest) => {
          return {
            objectId: guest.matching.label,
            data: [
              {
                zoneId: 'template',
                value: template,
              },
              {
                zoneId: 'chair',
                value: '',
              },
              {
                zoneId: 'number',
                value: '',
              },
              {
                zoneId: 'row',
                value: ''
              },
              {
                zoneId: 'block',
                value: ''
              },
              {
                zoneId: 'name',
                value: '',
              },
              {
                zoneId: 'surname',
                value: ''
              },
              {
                zoneId: 'company',
                value: '',
              },
              {
                zoneId: 'message',
                value: '',
              },
              {
                zoneId: 'title',
                value: ''
              }
            ]
          };
        });

      if (labels.length > 0) {
        await dispatch(addMatching({
          labels: labels,
          config: {
            params: {
              resetFields: true
            }
          }
        }));
      }
      template === "Default" ?
        openNotification(
          "bottomRight",
          "Stühle zurückgesetzt",
          "Alle Stühle des Events wurden zurückgesetzt.",
          true
        ) :
        openNotification(
          'bottomRight',
          'Wartungsdisplay angezeigt',
          "Alle Stühle des Events wurden auf das Wartungsdisplay gewechselt.",
          true
        )

      await dispatch(fetchLocations());
      await fetchEvent()
      setPatchedData(!patcheData);
    } catch (error) {
      console.error("Error resetting location:", error);
      openNotification(
        "bottomRight",
        "Fehler",
        "Stühle konnten nicht umgeschalten werden. Bitte später erneut versuchen.",
        false
      );
    }
  };


  return (
    <Button
      type="primary"
      className="add-event-button"
      icon={template === "Default" ? <RedoOutlined /> : <ToolOutlined/>}
      onClick={() => showResetConfirm()}
      style={{ marginLeft: marginLeft, marginBottom: 0 }}
    >
      {template === "Default" ? "Alle Stühle zurücksetzen" : "Wartungsdisplay anzeigen"}
    </Button>
  );
};

export default ResetButton;
